export const backdropStyles = () => ({
  position: 'fixed',
  backgroundColor: 'backdrop.dark',
  transition: '300ms',
  top: 0,
  left: 0,
  height: 'var(--app-height)',
  width: '100vw',
  zIndex: 1000000,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const imageContainerStyles = {
  height: 'auto',
  width: 'auto',
  maxHeight: '70vh',
  maxWidth: '70vw',
  position: 'relative',
};

export const closeButtonStyles = {
  position: 'absolute',
  top: '-32px',
  right: '-32px',
};

export const imageStyles = {
  display: 'block',
  height: 'auto',
  width: 'auto',
  maxHeight: '70vh',
  maxWidth: '70vw',
  borderRadius: '10px',
};

export const downloadButtonStyles = {
  mt: 1,
  alignSelf: 'flex-start',
};
